import React from "react";
import GenericDrawer from "./GenericDrawer.js";
import { useSelector } from "react-redux";
import {
  AccountSelectors,
  UserContextSelectors
} from "../../redux/selectors/index.js";
import { useDispatch } from "react-redux";
import { useClickOutside, useNoScroll } from "../../hooks/index.js";
import { AccountActionCreators } from "../../redux/action-creators/index.js";
import { DrawerType, VerticalTransition } from "../../constants/index.js";
import MyAccountArea from "../MyAccountArea/MyAccountArea.js";
import MyAccountAreaHeader from "../MyAccountArea/components/MyAccountAreaHeader/MyAccountAreaHeader.js";

const MyAccountAreaDrawer = () => {
  const myAccountAreaVisible = useSelector(AccountSelectors.drawerActive);
  const isMobile = useSelector(UserContextSelectors.isMobile);

  const dispatch = useDispatch();
  const drawerRef = useClickOutside(
    () => {
      dispatch(AccountActionCreators.toggleAccountDrawer());
    },
    {
      disabled: !myAccountAreaVisible,
      ignoreClass: "aCprofilePic"
    }
  );

  useNoScroll("myAccountAreaDrawer", myAccountAreaVisible);

  return (
    <GenericDrawer
      componentRef={drawerRef}
      className="myAccountAreaDrawer"
      isVisible={myAccountAreaVisible}
      menu={DrawerType.MyAccountArea}
      header={<MyAccountAreaHeader drawerType={DrawerType.MyAccountArea} />}
      verticalTransition={
        isMobile ? VerticalTransition.Right : VerticalTransition.Left
      }
    >
      <MyAccountArea />
    </GenericDrawer>
  );
};

export default React.memo(MyAccountAreaDrawer);
